import { createRouter, createWebHistory, RouterView } from "vue-router";
import homeRoutes from "@/router/homeRoutes";
import { IBreadcrumbMeta } from "cdp-fe-commons-layout";
import { useUserStore } from "@/stores/user";
import { useNotificationStore } from "@/stores/notification";
import { NotificationStatus } from "@/enums/components/general/NotificationStatus";
import { NotificationPosition } from "@/enums/components/general/NotificationPosition";
import enMessages from "@/locales/en.json";
import itMessages from "@/locales/it.json";
import { useServiceDetailStore } from "@/stores/service/serviceDetail";

declare module "vue-router" {
  interface RouteMeta {
    breadcrumb: IBreadcrumbMeta;
  }
}

const routes = [
  {
    path: "/",
    name: "Root",
    component: RouterView,
    meta: {
      title: "Sportello online",
      breadcrumb: {
        icon: "it-pa",
        customName: "Home"
      } as IBreadcrumbMeta
    },
    children: homeRoutes
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  const userStore = useUserStore();
  const serviceDetailStore = useServiceDetailStore();
  const notificationStore = useNotificationStore();

  const isAuthenticated = await userStore.isAuthenticated();


  if (to.path === '/login' && isAuthenticated) {
    return next({ name: 'Home' });
  }


  if (to.matched.some((record) => record.meta.requiresAuth) && !isAuthenticated) {
    if (from.path !== '/login') {
      const language = serviceDetailStore.language || 'en';
      const messages = language === 'it' ? itMessages : enMessages;

      notificationStore.addNotification({
        title: messages.authentication.title,
        message: messages.authentication.permission,
        status: NotificationStatus.ERROR,
        position: NotificationPosition.TOP,
        timeout: 2000,
        dismissable: true,
      });
    }

    return next({ path: '/login' });
  }


  if (!to.path.includes("richiestaonline") && to.query.tab) {
    const cleanQuery = { ...to.query };
    delete cleanQuery.tab;

    return next({ path: to.path, query: cleanQuery, replace: true });
  }



  next();
});

export default router;
